import { SxProps, Theme } from '@mui/material';

export const cardSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: '#1a1a1a',
  border: '1px solid #333'
};

export const sectionHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#464545',
  color: 'white',
  p: 2,
  borderRadius: '8px 8px 0 0'
};

export const cardContentSx: SxProps<Theme> = {
  backgroundColor: '#161616',
  color: 'white'
};

export const flexWrapBoxSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 3,
  mb: 3
};

export const fieldBoxSx: SxProps<Theme> = {
  flex: '1 1 300px',
  minWidth: 250
};

export const selectSx: SxProps<Theme> = {
  color: 'white',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#666' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#999' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
  '& .MuiSvgIcon-root': { color: 'white' }
};

export const selectMenuPaperSx: SxProps<Theme> = {
  backgroundColor: '#2a2a2a',
  color: 'white',
  '& .MuiMenuItem-root': {
    color: 'white',
    '&:hover': { backgroundColor: '#3a3a3a' },
    '&.Mui-selected': {
      backgroundColor: '#3b82f6',
      '&:hover': { backgroundColor: '#2563eb' }
    }
  }
};

export const textFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    color: 'white',
    '& fieldset': { borderColor: '#666' },
    '&:hover fieldset': { borderColor: '#999' },
    '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
  },
  '& input[type=number]': {
    '-moz-appearance': 'textfield'
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  }
};

export const dateFieldSx: SxProps<Theme> = {
  ...textFieldSx,
  '& .MuiSvgIcon-root': { color: 'white' },
  '& input::-webkit-calendar-picker-indicator': {
    filter: 'invert(1)'
  }
};

export const agreedPriceFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    color: 'white',
    backgroundColor: 'rgba(33, 150, 243, 0.1)',
    '& fieldset': { borderColor: 'rgba(33, 150, 243, 0.3)' },
    '&:hover fieldset': { borderColor: 'rgba(33, 150, 243, 0.5)' },
    '&.Mui-focused fieldset': { borderColor: '#2196f3' }
  },
  '& .MuiInputBase-input': {
    fontWeight: 'bold'
  },
  '& input[type=number]': {
    '-moz-appearance': 'textfield'
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  }
};

export const actionButtonsSx: SxProps<Theme> = {
  backgroundColor: '#2a2a2a',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  borderTop: '1px solid #444',
  pt: 3,
  mt: 0
};

export const whatsappDialogTitleSx: SxProps<Theme> = {
  bgcolor: '#075E54',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

export const whatsappDialogContentSx: SxProps<Theme> = {
  mt: 2,
  bgcolor: '#1e293b',
  color: 'white'
};

export const whatsappDialogTextSx: SxProps<Theme> = {
  color: '#e2e8f0'
};

export const whatsappPreviewBoxSx: SxProps<Theme> = {
  mt: 1,
  p: 2,
  bgcolor: '#2d3748',
  borderRadius: 1
};

export const whatsappDialogActionsSx: SxProps<Theme> = {
  bgcolor: '#1e293b',
  color: 'white'
};

export const reminderDialogTitleSx: SxProps<Theme> = {
  bgcolor: '#FF9800',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

export const reminderDialogContentSx: SxProps<Theme> = {
  mt: 2,
  bgcolor: '#1e293b',
  color: 'white'
};

export const reminderDialogTextSx: SxProps<Theme> = {
  color: '#e2e8f0'
};

export const reminderPreviewBoxSx: SxProps<Theme> = {
  mt: 1,
  p: 2,
  bgcolor: '#2d3748',
  borderRadius: 1
};

export const reminderDialogActionsSx: SxProps<Theme> = {
  bgcolor: '#1e293b',
  color: 'white'
};